import React, {
  useState, useEffect,
} from "react";
import { toast } from "react-toastify";
import {
  Modal,
  Button,
} from "antd";
import { markTestRunOnInstrument } from "../../../../../actions/chemistry";
import { getUser } from "../../../../../utils/helpers";

const LoadedSequenceModal = ({
  modalObj,
  setModalObj,
  fetchSequencesApi,
  selectedInstrument,
}) => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (modalObj.open) {
      setTitle(`Loaded for ${modalObj.sequence?.sequence_id}?`);
    }
  }, [modalObj.open, modalObj.sequence]);

  const handleConfirmLoaded = async () => {
    setLoading(true);
    const payload = {
      action: "load",
      test_in_sample_id: modalObj.sequence.samples_list.map((sample) => sample.tests_in_sample_id),
      user_id: getUser()?.id,
      sequence_id: modalObj.sequence.sequence_id,
    };
    const { success, message } = await markTestRunOnInstrument(payload);
    if (success) {
      setModalObj({ open: false, sequence: null });
      fetchSequencesApi(selectedInstrument, false);
    } else {
      toast.error(message);
    }
    setLoading(false);
  };

  return (
    <Modal
      centered
      destroyOnClose
      open={modalObj.open}
      title={title}
      closable={false}
      maskClosable={false}
      width="600px"
      footer={[
        <Button key="close" disabled={loading} onClick={() => setModalObj({ open: false, sequence: null })}>
          Close
        </Button>,
        <Button key="submit" type="primary" onClick={handleConfirmLoaded} loading={loading}>
          Confirm
        </Button>,
      ]}
    >
      <div className="Platemap__ModalBody">
        {modalObj.sequence?.samples_list.map((sample, idx) => <span className="Platemap__GenistaIdInModal" key={idx}>{`${sample.genista_id}: ${sample.internal_name}`}</span>)}
      </div>
    </Modal>
  );
};

export default LoadedSequenceModal;
